import React, {useState, useEffect} from 'react';
import {Switch, Redirect} from 'react-router-dom';

import {RouteWithLayout} from './components';
import {Main as MainLayout, Minimal as MinimalLayout} from './layouts';

import {
   NotFound as NotFoundView,
   SignIn as SignInView,
   Cliente as ClienteView,
   ListaTicket as ListaTicketView,
   VerTicket as TicketView,
   AbrirTicket as AbrirTicketView,
   Home as HomeView,
   Capacitaciones as CapacitacionesView,
   ProgramarSoporte as ProgramarAtencionView,
   reporteAtencion as ReporteAtencionView
} from './views';

const Routes = props => {
   const {logged} = props;
   const [esProduccion, setEsProduccion] = useState(false);
   useEffect(() => {
      setEsProduccion(
         !process.env.NODE_ENV !== 'production' && process.env.REACT_APP_DS_ENV === 'PROD'
      );
   }, []);

   return (
      <Switch>
         <Redirect exact from="/" to={logged ? 'home' : '/signIn'} />
         <RouteWithLayout
            component={SignInView}
            exact
            layout={MinimalLayout}
            path="/signIn"
            condition={!logged}
         />
         <RouteWithLayout
            component={HomeView}
            exact
            layout={MainLayout}
            path="/home"
            condition={logged}
         />
         <RouteWithLayout
            component={AbrirTicketView}
            exact
            layout={MainLayout}
            path="/abrirTicket"
            condition={logged}
         />
         <RouteWithLayout
            component={ClienteView}
            exact
            layout={MainLayout}
            path="/perfil"
            condition={logged}
         />
         <RouteWithLayout
            component={ListaTicketView}
            exact
            layout={MainLayout}
            path="/listaTicket"
            condition={logged}
         />
         <RouteWithLayout
            component={TicketView}
            exact
            layout={MainLayout}
            path="/verTicket"
            condition={logged}
         />
         <RouteWithLayout
            component={TicketView}
            exact
            layout={MainLayout}
            path="/verTicket/:ticketCod"
            condition={logged}
         />
         <RouteWithLayout
            component={CapacitacionesView}
            exact
            layout={MainLayout}
            path="/capacitaciones/:codigo"
            condition={logged}
         />
         <RouteWithLayout
            component={ProgramarAtencionView}
            exact
            layout={MainLayout}
            path="/programarAtencion"
            condition={logged}
         />
         <RouteWithLayout
            component={ReporteAtencionView}
            exact
            layout={MainLayout}
            path="/reporteAtencion"
            condition={logged}
         />
         <RouteWithLayout
            component={NotFoundView}
            exact
            layout={logged ? MainLayout : MinimalLayout}
            path="/notFound"
         />
         <Redirect to="/notFound" />
      </Switch>
   );
};

export default Routes;
